/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    margin: theme.spacing(2),
    padding: theme.spacing(2),
    borderRadius: theme.spacing(0.65),
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.action.selected,
    border: `${theme.spacing(0.125)}px solid ${theme.palette.primary.main}`,
  },
  subTextWrap: {
    width: '100%',
    fontWeight: 700,
    alignSelf: 'center',
  },
  subText: {
    fontWeight: 700,
  },
  iconWrap: {
    marginRight: theme.spacing(1.5),
    color: theme.palette.primary.main
  },
}));
